/**
 * パスパラメータを保持したままリダイレクトするコンポーネント
 *
 * React Router の <Navigate> は path params (:id 等) を自動置換しないため、
 * 動的ルートのリダイレクトにはこのヘルパーを使用する。
 *
 * 使用例:
 *   <Route path="/old/:id/edit" element={<RedirectWithParams to="/new/:id/edit" />} />
 */
import { Navigate, useLocation, useParams } from "react-router-dom";

interface RedirectWithParamsProps {
    /** 遷移先URL (:id 等のパラメータを含む) */
    to: string;
}

export function RedirectWithParams({ to }: RedirectWithParamsProps) {
    const params = useParams();
    const { search, hash } = useLocation();

    let target = to;
    for (const [key, value] of Object.entries(params)) {
        if (value != null) {
            target = target.replace(`:${key}`, value);
        }
    }

    return <Navigate to={`${target}${search}${hash}`} replace />;
}
